import {
  TKwikUIInputTimeSize,
  VKwikUIInputTimeSize
} from "./input-time.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";
  const isArray = (x: Array<any>) => Array.isArray(x);

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    isShowLabelOutside: isBoolean,
    items: isArray,
    label: isString,
    mode: isString,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputTimeSize) => VKwikUIInputTimeSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
